import {TimeScale} from "./global";

const sTs = 1000, mTs = 60*1000, HTs = 60*60*1000, dTs = 24*60*60*1000, wTs = 7*24*60*60*1000;

const MTs = (curTs) => DateFormat.getMonthDays(new Date(curTs))*dTs

const yTs = (curTs) => {
  if(DateFormat.isLeapYear(curTs))return 366*dTs;
  return  365*dTs
}

const zeroArray = (n)=>{
  let ret = []
  for(let i=0;i<n;i++)ret.push(0)
  return ret
}

const firstTsOfWeek = (assign) => { //获取本周周一的时间戳
  let cdt = new Date(assign).getDay()
  return DateFormat.formatTs('d',assign - ((cdt === 0?7:cdt) - 1) * dTs)
}

const scaleToTs = (scale,curTs) => { //获得时间戳对应的步长
  switch (scale) {
    case TimeScale.s:return sTs;
    case TimeScale.m:return mTs;
    case TimeScale.H:return HTs;
    case TimeScale.d:return dTs;
    case TimeScale.w:return wTs;
    case TimeScale.M:return MTs(curTs);
    case TimeScale.y:return yTs(curTs);
  }
}

const DateFormat = {
    Decade:"Decade",
    Year:"Year",
    M:"Month",
    d:24*60*60*1000,
    H:60*60*1000,
    m:60*1000,
    s:1000,
    Week:"Week",
    Season:"Season",
    FMT_01:"yyyy-MM-dd HH:mm:ss",
    FMT_02:"yyyy-MM-dd",
    format:(type,ts)=>{
      type = type?type:DateFormat.FMT_01
      if(ts && ts.constructor === Array) return ts.map(i=>DateFormat.format(type,i))
      let dt = ts?new Date(ts):new Date()
      const dtList = {
        "M+": dt.getMonth() + 1,
        "d+": dt.getDate(),
        "H+": dt.getHours(),
        "m+": dt.getMinutes(),
        "s+": dt.getSeconds(),
        "q+": Math.floor((dt.getMonth() + 3) / 3),
        "S+": dt.getMilliseconds()
      };
      if (/(y+)/i.test(type)) {
        type = type.replace(RegExp.$1, (dt.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in dtList) {
        if (new RegExp("(" + k + ")").test(type)) {
          type = type.replace(RegExp.$1, RegExp.$1.length === 1 ? dtList[k] : ("00" + dtList[k]).substr(("" + dtList[k]).length));
        }
      }
      return type;
    }, //返回固定格式的日期 如 yyyy-MM-dd 返回2020-11-04
    formatTs:(scale,assign)=>{
      let dt = assign?new Date(assign):new Date()
      let s = dt.getSeconds(),m = dt.getMinutes(),h = dt.getHours(),d = dt.getDate(),M = dt.getMonth(),y = dt.getFullYear()
      switch (scale){
        case TimeScale.s : return new Date(y,M,d,h,m,s).getTime();
        case TimeScale.m : return new Date(y,M,d,h,m).getTime();
        case TimeScale.H : return new Date(y,M,d,h).getTime();
        case TimeScale.d : return new Date(y,M,d).getTime();
        case TimeScale.w : return firstTsOfWeek(assign??new Date().getTime());
        case TimeScale.M : return new Date(y,M).getTime();
        case TimeScale.y : return new Date(y,0).getTime();
      }
    }, //格式化时间戳，获得整点时间戳
    timeMove3:(scale,exp,assign) => {
      let dt = assign?new Date(assign):new Date(),symbol = exp.substring(0,1),num = parseInt(exp.substring(1,exp.length));
      switch (scale){
        case TimeScale.s : symbol==="+"?dt.setSeconds(dt.getSeconds()+num):dt.setSeconds(dt.getSeconds()-num);break;
        case TimeScale.m : symbol==="+"?dt.setMinutes(dt.getMinutes()+num):dt.setMinutes(dt.getMinutes()-num);break;
        case TimeScale.H : symbol==="+"?dt.setHours(dt.getHours()+num):dt.setHours(dt.getHours()-num);break;
        case TimeScale.d : symbol==="+"?dt.setDate(dt.getDate()+num):dt.setDate(dt.getDate()-num);break;
        case TimeScale.w : symbol==="+"?dt.setDate(dt.getDate()+num*7):dt.setDate(dt.getDate()-num*7);break;
        case TimeScale.M : symbol==="+"?dt.setMonth(dt.getMonth()+num):dt.setMonth(dt.getMonth()-num);break;
        case TimeScale.y : symbol==="+"?dt.setFullYear(dt.getFullYear()+num):dt.setFullYear(dt.getFullYear()-num);break;
      }
      return dt.getTime();
    },//移动时间戳, "m","+4",16XXXX
    dateRange3:(scale,assign) => [DateFormat.formatTs(scale,assign),DateFormat.formatTs(scale,DateFormat.timeMove3(scale,"+1",assign))],
    tsSeries:(dateRange,scale) => {
      let start = dateRange[0],end = dateRange[1],ret = []
      while (start < end){
        ret.push(start)
        start += scaleToTs(scale,start)
      }
      return ret;
    }, // [16XXXX,16XXXX]
    valueSeries:(dateRange,scale,defaultV) => {
      let start = dateRange[0],end = dateRange[1],ret = []
      while (start < end){
        ret.push(defaultV||0)
        start += scaleToTs(scale,start)
      }
      return ret;
    },// [0,0]
    timeValueSeries:(dateRange,scale,defaultV) => {
      let start = dateRange[0],end = dateRange[1],ret = []
      while (start < end){
        ret.push([start,defaultV||0])
        start += scaleToTs(scale,start)
      }
      return ret;
    },// [[16XXXX,0],[16XXXXX,0]]
    objectSeries:(dateRange,scale,prop) => {
      let start = dateRange[0],end = dateRange[1],ret = []
      while (start < end){
        ret.push(Object.assign({timescale:start},prop))
        start += scaleToTs(scale,start)
      }
      return ret;
    },// [{timescale:16XXXX,name:'0'},{timescale:16XXXX,name:'1'}]
    adjustItem:(series,index,scale,exp) =>{
    series[index] = DateFormat.timeMove3(scale,exp,series[index])
    return series;
  },
    queryFormat:(scale) => {
      switch (scale){
        case TimeScale.s: return  "yyyy-MM-dd HH:mm:ss";
        case TimeScale.m: return  "yyyy-MM-dd HH:mm:00";
        case TimeScale.H: return  "yyyy-MM-dd HH:00:00";
        case TimeScale.d: return  "yyyy-MM-dd";
        case TimeScale.w: return  "yyyy-MM-dd";
        case TimeScale.M: return  "yyyy-MM";
        case TimeScale.y: return  "yyyy";
      }
    },
    queryDateRange:(range,assign,isEnergy) => {
    let scale = DateFormat.scaleMove(range,"-1") //时间尺度比范围小
    let dateRange = DateFormat.dateRange3(range,assign) //获取起始点
    if(isEnergy) dateRange = DateFormat.adjustItem(dateRange,0,scale,"+1") //如果是电量，就调整范围
    return DateFormat.format(DateFormat.queryFormat(scale),dateRange).join("~")//得到格式并返回
  },

    timeMove:(exp,fmt,assign)=>{
      let dt = new Date()
      if(!exp)return;
      if(assign)dt = new Date(assign)
      let scale = exp.substring(0,1)
      let symbol = exp.substring(1,2)
      let num = parseInt(exp.substring(2,exp.length))
      switch (scale){
        case "s": symbol==="+"?dt.setSeconds(dt.getSeconds()+num):dt.setSeconds(dt.getSeconds()-num);break;
        case "m": symbol==="+"?dt.setMinutes(dt.getMinutes()+num):dt.setMinutes(dt.getMinutes()-num);break;
        case "H": symbol==="+"?dt.setHours(dt.getHours()+num):dt.setHours(dt.getHours()-num);break;
        case "d": symbol==="+"?dt.setDate(dt.getDate()+num):dt.setDate(dt.getDate()-num);break;
        case "w": symbol==="+"?dt.setDate(dt.getDate()+num*7):dt.setDate(dt.getDate()-num*7);break;
        case "M": symbol==="+"?dt.setMonth(dt.getMonth()+num):dt.setMonth(dt.getMonth()-num);break;
        case "y": symbol==="+"?dt.setFullYear(dt.getFullYear()+num):dt.setFullYear(dt.getFullYear()-num);break;
      }
      return fmt==="dt"?DateFormat.retFormat(dt,scale):dt.getTime()
    },
    dateRange:(exp,fmt,assign)=>{ //返回2个点[a,b]
      let retA,retB = 0,scale="";
      let dt = new Date()
      if(assign)dt = new Date(assign)
      scale = exp.length > 4 ? exp.substring(4,exp.length):exp
      let symbol = "+0";
      if(exp.includes("last"))symbol = "-1";
      if(exp.includes("next"))symbol = "+1";
      let start = DateFormat.formatTs(scale,dt)
      retA = DateFormat.timeMove(scale+symbol,"ts",start)
      // console.log(retA,scale+symbol);
      retB = DateFormat.timeMove(scale+"+1","ts",retA)
      return fmt==="dt"?DateFormat.retFormat([retA,retB],scale):[retA,retB]
    },
    rangeFormat:(range,fmtStr)=>{
      return [DateFormat.format(fmtStr,range[0]),DateFormat.format(fmtStr,range[1])]
    },
    retFormat:(ret,fmt)=>{ //传入1个或两个时间戳
      let fmtStr = "yyyy-MM-dd"
      switch (fmt){
        case "y": fmtStr = "yyyy";break;
        case "M": fmtStr = "yyyy-MM";break;
        case "d": fmtStr = "yyyy-MM-dd";break;
        case "H": fmtStr = "yyyy-MM-dd_HH:00:00";break;
        case "H2": fmtStr = "HH:00";break;
        case "m": fmtStr = "yyyy-MM-dd_HH:mm:00";break;
      }
      if(ret instanceof Array) return [DateFormat.format(fmtStr,ret[0]),DateFormat.format(fmtStr,ret[1])];
      else return DateFormat.format(fmtStr,ret)
    },
    scaleMove:(scale,exp) => {
      if(scale === 'w') scale = 'M';
      let scaleList = ['s','m','H','d','M','y']
      let index = scaleList.findIndex(s=>s === scale),symbol = exp.substring(0,1),num = parseInt(exp.substring(1,exp.length));
      let indexTarget = (symbol === "+"?(index + num):(index - num))
      return scaleList[indexTarget]
    },
    categorySeries3:(range,assign,format) => {
    let scale = DateFormat.scaleMove(range,"-1"),ret = []
    let dateRange = DateFormat.dateRange3(range,assign),start = dateRange[0],end = dateRange[1]
    while (start < end){
      ret.push(DateFormat.format(format,start))
      start += scaleToTs(scale,start)
    }
    return ret
  },



    accCorrect:(dateRange,scale,fmt)=>{ //这里来的是一个范围
      let retA = new Date(dateRange[0])
      let retB = new Date(dateRange[1])
      retA = DateFormat.timeMove(scale+"+1",null,retA);
      return fmt === "dt"? DateFormat.retFormat([retA,retB],scale) : [new Date(retA).getTime(),new Date(retB).getTime()]
    },
    series:(dateRange,timescale,isAcc,fmt,isKV)=>{ //生成一个时序
      let newRange = isAcc?DateFormat.accCorrect(dateRange,timescale):dateRange
      let retA = new Date(newRange[0])
      let retB = new Date(newRange[1])
      let retList = []
      while (retA.getTime() < retB.getTime()){
        let v = fmt?DateFormat.format(fmt,retA):retA
        isKV?retList.push([v,0]):retList.push(v)
        retA = new Date(DateFormat.timeMove(timescale+"+1",null,retA))
      }
      return retList;
    },
    seriesMove:(datas)=>{
      let newList = [];
      datas.map((item,index)=>{
        let newI = parseInt(item[0]) + 24*60*60*1000;
        newList.push([newI,item[1]])
      })
      return newList;
    },
    nowAfter:(datas)=>{
      let now = new Date().getTime();
      let list = []
      datas.map((item,index)=>{
        if(parseInt(item[0]) > now)list.push(item);
      })
      return list;
    },
    seriesFormat:(dList,scale)=>{  //对序列进行指定格式的格式化
      let fmtStr = "dd",retList = [];
      switch (scale){
        case "y" : fmtStr = "yyyy"; break;
        case "M" : fmtStr = "yyyy-MM"; break;
        case "H" : fmtStr = "HH"; break;
        case "m" : fmtStr = "mm"; break;
      }
      if(scale === "ChineseWeek")dList.map((item,index)=>retList.push([DateFormat.getChinese(item[0]),item[1]]))
      else Object.keys(dList).forEach(it=>retList.push([DateFormat.format(fmtStr,parseInt(it)),dList[it]]))
      return retList
    },
    retCorrect:(retList,scale,fmt)=>{ //对结果的修正，包括时间戳。这里来的是一个时序
      let a = []
      // eslint-disable-next-line no-unused-expressions
      retList?.map(it=>{
          let ts = DateFormat.timeMove(scale+"-1",null,it[0])
        let tsStr = fmt?DateFormat.format(fmt,ts):ts
        a.push([tsStr,it[1]])
      })
      return a;
    },
    supplyArray:(array, targetN)=> array.concat(zeroArray(targetN)).slice(0,targetN), //补0



    categorySeries:(assign,scale,fmt) => {
      let dt = new Date(assign),fmtStr = "",num = 0,ret=[],start,end;
      switch (scale){
        case "H":
          num = 24;
          start = DateFormat.formatTs("d")
          end = DateFormat.formatTs("d",DateFormat.timeMove("d+1"),"",assign)
          break;
        case "d":
          num = DateFormat.getMonthDays(dt)
          start = DateFormat.formatTs("M")
          end = DateFormat.formatTs("M",DateFormat.timeMove("M+1"),"",assign)
          break;
        case "w":
          num = 7;
          break;
        case "M":
          num = 12
          start = DateFormat.formatTs("y")
          end = DateFormat.formatTs("y",DateFormat.timeMove("y+1"),"",assign)
          break;
      }
      while (start < end){
        ret.push(DateFormat.format(fmt,start))
        start = DateFormat.timeMove(scale+"+1","",start)
      }
      return ret;
    },
    rangeMove:(dateRange,exp,fmt)=>{
      let retA = new Date(dateRange[0])
      let retB = new Date(dateRange[1])
      let scale = exp.substring(0,1)
      let symbol = exp.substring(1,2)
      let num = parseInt(exp.substring(2,exp.length))
      switch (scale){
        case "H":
          symbol==="+"?retA.setHours(retA.getHours()+num):retA.setHours(retA.getHours()-num);
          symbol==="+"?retB.setHours(retB.getHours()+num):retB.setHours(retB.getHours()-num);
          break;
        case "d":{
          symbol==="+"?retA.setDate(retA.getDate()+num):retA.setDate(retA.getDate()-num);
          symbol==="+"?retB.setDate(retB.getDate()+num):retB.setDate(retB.getDate()-num);
          break;
        }
      }
      return fmt === "dt"? DateFormat.retFormat([retA,retB],scale) : [retA.getTime(),retB.getTime()]
    },
    maxValidDate:(dt)=>{
        return dt/1000;
    },
    getThisMonth:(dt)=>{ //返回本月所代表的时间范围，如2020-11-01~2020-12-01
        let newDate = new Date(dt);
        let start = DateFormat.format("yyyy-MM-dd",DateFormat.getFirstDay(newDate,DateFormat.Month));
        let nextMonth = DateFormat.getTimeMove(newDate,1,DateFormat.Month);
        let nextFirstDay = DateFormat.getFirstDay(nextMonth,DateFormat.Month);
        let end = DateFormat.format("yyyy-MM-dd",nextFirstDay);
        return start + "~" + end;
    },
    getThisYear:(dt)=>{ //返回本年所代表的的时间范围，如2020-01-01~2021-01-01
        let start = DateFormat.getFirstDay(dt,DateFormat.Year)
        let nextYear = DateFormat.getFirstDay(DateFormat.getTimeMove(dt,1,DateFormat.Year),DateFormat.Year);
        return DateFormat.format("yyyy-MM-dd",start) + "~" + DateFormat.format("yyyy-MM-dd",nextYear);
    },
    getEnglish:(date)=>{ //获得某个日期是星期几 返回英文
        let dt = new Date(date)
        const list = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
        let index = dt.getDay();
        return list[index];
    },
    getChinese:(ts)=>{ //获得某个日期是星期几 返回中文
        let dt = new Date(ts);
        // const list = ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"];
        const list = ["周日","周一","周二","周三","周四","周五","周六"];
        let index = dt.getDay();
        return list[index];
    },
    isLeapYear:(assign)=>{ //是不是闰年
        let year = assign?new Date(assign).getFullYear():new Date().getFullYear()
        return ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
    },
    getMonthDays:(assign)=>{//获得某个月的天数
        const list = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if(DateFormat.isLeapYear(assign) && new Date(assign).getMonth() === 1) return 29;
        else return list[new Date(assign).getMonth()];
    },
    getMonthDayNames:(date)=>{
        let nameList = [];
        let monthDays = DateFormat.getMonthDays(date);
        let month = date.getMonth() + 1 ;
        for(let i=1;i<=monthDays;i++){
            nameList.push(month + "-" + i);
        }
        return nameList;
    },
    getToday:()=>{ //获得当天的具体时刻
        return DateFormat.format("yyyy-MM-dd HH:mm:ss",new Date());
    },
    getDayString:(dt)=>{ //获得当天的日期
        return DateFormat.format("yyyy-MM-dd",new Date(dt));
    },
    getMoment:(dt)=>{ //获得某天的具体时刻
        return DateFormat.format("yyyy-MM-dd HH:mm:ss",new Date(dt));
    },
    getTimeMove:(dt,index,type)=>{ //日期在各个时间尺度的加减
        let date = new Date(dt);
        switch(type){
            case DateFormat.Year:
                date.setFullYear(date.getFullYear() + index);
                break;
            case DateFormat.Month:
                let tempDate = new Date(dt);
                date.setDate(1);
                date.setMonth(date.getMonth() + index);
                let monthDays = DateFormat.getMonthDays(date);
                if(monthDays < tempDate.getDate())date.setDate(monthDays);
                break;
            case DateFormat.Day:
                date.setDate(date.getDate() + index);
                break;
            case DateFormat.Hour:
                date.setHours(date.getHours() + index);
                break;
            case DateFormat.Minute:
                date.setMinutes(date.getMinutes() + index);
                break;
            case DateFormat.Second:
                date.setSeconds(date.getSeconds() + index);
                break;
            case DateFormat.Week:
                date.setDate(date.getDate() + 7*index);
                break;
            case DateFormat.Season:
                date.setMonth(date.getMonth() + 3*index);
                break;
          default:return date;
        }
        return date;
    },
    nextWindowTs:(assign)=>{
      let ts = assign?(new Date(assign).getTime()):(new Date().getTime())

    },
    isBigger:(dt1,dt2)=>{ //比较两个日期的大小
        const gap = dt1.getTime() - dt2.getTime();
        return gap > 0;
    },
    getDaysOfRange:(dt1,dt2)=>{ //获得两个日期之间的天数
        let dateOne = Math.ceil(( dt1 - new Date(dt1.getFullYear().toString()))/(24*60*60*1000))+1;
        let dateTwo = Math.ceil(( dt2 - new Date(dt2.getFullYear().toString()))/(24*60*60*1000))+1;
        return parseInt(dateTwo.toString()) - parseInt(dateOne.toString());
    },
    getFirstDay:(dt,type)=>{ //获得某个时间段的第一天
        let date = new Date(dt);
        switch (type) {
            case DateFormat.Week:
                let weekDay = date.getDay();
                date.setDate(date.getDate() - weekDay + 1);
                break;
            case DateFormat.Month:
                date.setDate(1);
                break;
            case DateFormat.Season:
                let m = date.getMonth();
                if(m < 3)date.setMonth(0);
                else if(2 < m && m < 6) date.setMonth(3);
                else if(5 < m && m < 9) date.setMonth(6);
                else if(8 < m && m < 11) date.setMonth(9);
                date.setDate(1);
                break;
            case DateFormat.Year:
                date.setMonth(0);
                date.setDate(1);
                break;
          default:return date;
        }
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        return date;
    },
    isLastDayOfMonth:(dt)=>{
        let newDate = new Date(dt);
        return newDate.getDate() === DateFormat.getMonthDays(newDate);

    },
    getMonthWeek:(dt)=>{
        let date = new Date(dt)
        let weekDay = date.getDay() || 7;
        return Math.ceil((date.getDate() + 6 - weekDay) / 7);
    },
    getYearWeek:(dt)=>{ //获得当前所在的周是全年的第几周
        let date = new Date(dt)
        let end = new Date(date.getTime());
        let start = DateFormat.getFirstDay(date,DateFormat.Year);
        let d = Math.round((end.valueOf() - start.valueOf()) / 86400000);
        return Math.ceil((d + ((start.getDay() + 1) - 1)) / 7);
    },
    isSameTime:(dt1,dt2,timeScale)=>{ //比较两个时间在某个尺度上是否一致
        let isSame = true;
        switch (timeScale){
          case DateFormat.Year:
            if(dt1.getFullYear() !== dt2.getFullYear()) isSame = false;
            break;
          case DateFormat.Month:
            if(dt1.getFullYear() !== dt2.getFullYear()) isSame = false;
            if(dt1.getMonth() !== dt2.getMonth()) isSame = false;
            break;
          case DateFormat.Day:
            if(dt1.getFullYear() !== dt2.getFullYear())isSame = false;
            if(dt1.getMonth() !== dt2.getMonth())isSame = false;
            if(dt1.getDate() !== dt2.getDate())isSame = false;
            break;
          case DateFormat.Week:
            if(dt1.getFullYear() !== dt2.getFullYear())isSame = false;
            if(dt1.getMonth() !== dt2.getMonth())isSame = false;
            if(DateFormat.getYearWeek(dt1) !== DateFormat.getYearWeek(dt2)) isSame = false;
            break;
          case DateFormat.Hour:
            if(dt1.getFullYear() !== dt2.getFullYear())isSame = false;
            if(dt1.getMonth() !== dt2.getMonth())isSame = false;
            if(dt1.getDate() !== dt2.getDate())isSame = false;
            if(dt1.getHours() !== dt2.getHours())isSame = false;
            break;
          default:
            if(dt1.valueOf() !== dt2.valueOf())isSame = false;
        }
        return isSame;
    },
    formatTime:(dt,timeScale)=>{ //将一个时间尾数置位0
        let newDate = new Date(dt);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        if(timeScale === TimeScale.Day)newDate.setHours(0);
        if(timeScale === TimeScale.Month){
            newDate.setDate(1);
            newDate.setHours(0);
        }
        if(timeScale === TimeScale.Year){
            newDate.setMonth(0);
            newDate.setDate(1);
            newDate.setHours(0);
        }
        return newDate;
    },
    timeScaleToDateScale:(timeScale)=>{
        if(timeScale === TimeScale.Minute) return DateFormat.Hour;
        if(timeScale === TimeScale.Hour) return DateFormat.Day;
        if(timeScale === TimeScale.Day) return DateFormat.Month;
        if(timeScale === TimeScale.Month) return DateFormat.Year;
        if(timeScale === TimeScale.Year) return DateFormat.Decade;
    },
    timeScaleToDateRange:(timeScale)=>{
        if(timeScale === TimeScale.Hour) return "yyyy-MM-dd";
        if(timeScale === TimeScale.Day) return "yyyy-MM";
        if(timeScale === TimeScale.Month) return "yyyy";
        return "yyyy-MM-dd HH:mm:ss";
    },
    dateDifference:(date)=>{ //比较某个时间戳
        const minute = 1000 * 60;
        const hour = minute * 60;
        const day = hour * 24;
        const week = day * 7;
        const month = day * 30;
        const year = day * 365;
        let diffValue = new Date().getTime() - new Date(date).valueOf();
        if(diffValue < minute) return "刚刚";
        const yearGap = diffValue / year;
        const monthGap = diffValue / month;
        const weekGap = diffValue / week;
        const dayGap = diffValue / day;
        const hourGap = diffValue / hour;
        const minuteGap = diffValue / minute;
        if(yearGap >= 1) return parseInt(yearGap.toString()) + "年前";
        if(monthGap >= 1) return parseInt(monthGap.toString()) + "月前";
        if(weekGap >= 1) return parseInt(weekGap.toString()) + "周前";
        if(dayGap >= 1) return parseInt(dayGap.toString()) + "天前";
        if(hourGap >= 1) return parseInt(hourGap.toString()) + "小时前";
        if(minuteGap >= 1) return parseInt(minuteGap.toString()) + "分钟前";
        return "未知";
    },
    nextQuarter:(assign)=>{
      let dt = assign?new Date(assign):new Date()
      let m = dt.getMinutes()
      if(m<15)m=15
      else if(m>=15 && m<30)m=30
      else if(m>=30 && m<45)m=45
      else if(m>=45 && m<=59){
        m=0;
        dt.setHours(dt.getHours()+1)
      }
      dt.setMinutes(m)
      dt.setSeconds(0)
      dt.setMilliseconds(0)
      return dt.getTime()
    }
};


export default DateFormat
